// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-input-error {
  --tw-text-opacity: 1;
  color: rgb(224 36 36 / var(--tw-text-opacity));
  vertical-align: baseline;
  min-height: calc(6 * var(--ds-unit));
}

.form-input-error__icon {
  margin-right: var(--base-sizes-1-5);
  font-size: .75em;
}

.form-input-error__message {
  font-size: .75rem;
  line-height: 1rem;
  font-weight: var(--base-font-weight-semibold);
}
`, "",{"version":3,"sources":["webpack://./home/autoboss/ipfabric-product/services/frontend/app/components/FormInputError/FormInputError.css","webpack://./services/frontend/app/components/FormInputError/FormInputError.css"],"names":[],"mappings":"AADA;ECEE,oBAAoB;EACpB,8CAA8C;EAC9C,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,6CAA6C;AAC/C","sourcesContent":[".form-input-error {\n\n  --tw-text-opacity: 1;\n\n  color: rgb(224 36 36 / var(--tw-text-opacity));\n\n  vertical-align: baseline;\n\n  min-height: calc(6 * var(--ds-unit))\n}\n\n.form-input-error__icon {\n\n  margin-right: var(--base-sizes-1-5);\n\n  font-size: 0.75em\n}\n\n.form-input-error__message {\n\n  font-size: 0.75rem;\n\n  line-height: 1rem;\n\n  font-weight: var(--base-font-weight-semibold)\n}\n",".form-input-error {\n  --tw-text-opacity: 1;\n  color: rgb(224 36 36 / var(--tw-text-opacity));\n  vertical-align: baseline;\n  min-height: calc(6 * var(--ds-unit));\n}\n\n.form-input-error__icon {\n  margin-right: var(--base-sizes-1-5);\n  font-size: .75em;\n}\n\n.form-input-error__message {\n  font-size: .75rem;\n  line-height: 1rem;\n  font-weight: var(--base-font-weight-semibold);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
